import { useKrakenQuery } from '@/components/GraphQLClient';
import { useAuth } from '@/components/Providers/Auth';
import { useAccountNumberContext } from '@/context/AccountNumberContext/withFetch/AccountNumberContext';
import CanSwitchToMeasuredTariff from '@/hooks/usage/useCanSwitchToMeasuredTariff/CanSwitchToMeasuredTariff.graphql';
import { canSwitchToMeasuredTariffSchema } from '@/hooks/usage/validations';
import { useSyncFeatureFlag } from '@/hooks/utils/useFeatureFlags';
import { FeatureNames } from '@/types/features';

type CanSwitchToMeasuredTariffResponse = {
  account: {
    potentialSwitchToMeasured: {
      canSwitch: boolean;
    };
  };
};
export const useCanSwitchToMeasuredTariff = () => {
  const { accountNumber } = useAccountNumberContext();

  const { isAuthenticated } = useAuth();

  const switchToMeasuredEnabled = useSyncFeatureFlag(
    FeatureNames.SwitchToMeasured
  );

  return useKrakenQuery({
    queryKey: ['canSwitchToMeasuredTariff'],
    query: CanSwitchToMeasuredTariff,
    validateFn(response) {
      return canSwitchToMeasuredTariffSchema.validate(response);
    },
    select: (data: CanSwitchToMeasuredTariffResponse) =>
      data.account.potentialSwitchToMeasured.canSwitch,
    enabled: Boolean(
      isAuthenticated && accountNumber && switchToMeasuredEnabled
    ),
    variables: { accountNumber },
    gcTime: 0,
  });
};
